/** Pure CDDS / onboarding helpers (no @/ imports — runnable under node --test). */

export type CddsNavContext = {
  persyaratan_accepted?: boolean
  cdds_submitted_at?: string | null
  awaiting_approval?: boolean
}

export function cddsTitleI18nKey(formCode: string): string {
  return `cdds.title.${formCode.replace(/\./g, '_')}`
}

export function cddsContinueIsSecondary(params: { code: string; stepSigned: boolean }): boolean {
  return params.code !== '10' && params.stepSigned
}

export function needsCdds10Submit(ctx: CddsNavContext): boolean {
  return Boolean(ctx.persyaratan_accepted && !ctx.cdds_submitted_at && !ctx.awaiting_approval)
}

export function persyaratanCddsHref(ctx: CddsNavContext): string {
  return needsCdds10Submit(ctx) ? '/register/cdds/10' : '/register/cdds'
}

const CDDS_WALK = ['01', '02', '03', '04', '05.2', '06.2', '07', '08', '09', '10']

/** Explicit URL code. A WALK code stays itself. Unpadded and 05/06 aliases canonicalize. Anything else is unknown. */
export function resolveCddsCode(code: string): string | 'unknown' {
  if (CDDS_WALK.includes(code)) return code
  if (code === '5' || code === '05') return '05.2'
  if (code === '6' || code === '06') return '06.2'
  if (/^(?:[1-9]|10)$/.test(code)) return code.padStart(2, '0')
  return 'unknown'
}

export function cddsReadOnly(params: {
  statusLoading: boolean
  editableStatus: boolean
  code: string
  progressComplete?: boolean
  signed10?: boolean
  awaitingApproval?: boolean
}): boolean {
  if (params.statusLoading || !params.editableStatus) return true
  if (params.code === '10') {
    return Boolean(params.signed10 || params.awaitingApproval)
  }
  return Boolean(params.progressComplete)
}

export function cddsSubmitDisabled(params: {
  yaPending: boolean
  readOnly: boolean
  code: string
  progressComplete?: boolean
}): boolean {
  return params.yaPending || params.readOnly || (params.code === '10' && !params.progressComplete)
}

export function isGrandfatheredCddsParagraph(params: {
  readOnly: boolean
  stepSigned: boolean
  needTicks: boolean
  index: number
  ticks: string[]
}): boolean {
  if (!params.readOnly || !params.stepSigned || !params.needTicks) return false
  return !params.ticks.includes(String(params.index))
}
